import React from 'react'

const CredentialSteps = ({...r}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" {...r}>
      <g clipPath="url(#credential-step-a)">
        <path
          fill="#00033A"
          d="M34.596 8.466a3.375 3.375 0 00-3.376-3.375H15.11a3.377 3.377 0 00-3.377 3.375l-.096 36.151a3.377 3.377 0 003.377 3.376h16.111a3.375 3.375 0 003.376-3.376l.004-1.234-1.334.031-.004 1.17a2.046 2.046 0 01-2.048 2.046l-16.127-.012a2.049 2.049 0 01-2.047-2.049l.123-36.118c0-1.13.918-2.047 2.05-2.046l1.863.001c.394 0 .541 0 .564.5.024.519.38.837.863.988.081.026 2.43.04 4.78.042h1c1.974-.002 3.71-.013 3.78-.034.483-.151.84-.469.865-.987.024-.5.17-.5.563-.5l1.848.001a2.05 2.05 0 012.047 2.05L33.223 28h1.322l.051-19.534z"
        ></path>
        <path
          stroke="#126FFF"
          strokeLinecap="round"
          strokeWidth="1.6"
          d="M20.606 14.91h8.242M20.606 20h8.242m-8.242 5.09h8.242"
        ></path>
        <path
          fill="#126FFF"
          d="M17.09 16a1.09 1.09 0 100-2.182 1.09 1.09 0 000 2.182zm0 5.09a1.09 1.09 0 100-2.18 1.09 1.09 0 000 2.18zm0 5.092a1.09 1.09 0 100-2.182 1.09 1.09 0 000 2.182z"
        ></path>
        <path
          fill="#126FFF"
          fillRule="evenodd"
          stroke="#126FFF"
          strokeWidth="0.3"
          d="M33.778 42.742a6.48 6.48 0 01-1.665-.364l-.019-.008a6.523 6.523 0 01-1.046-.485c-3.183-1.828-4.363-5.92-2.626-9.12a6.43 6.43 0 011.42-1.784.09.09 0 00.021-.018c1.975-1.713 4.875-2.097 7.326-.771l-.407.767c-.114.214-.012.352.223.307l2.103-.4c.235-.045.353-.268.263-.497l-.807-2.038c-.09-.23-.257-.241-.37-.028l-.41.77a7.704 7.704 0 00-6.38-.492l-.004.001-.023.008a7.591 7.591 0 00-3.971 3.375 5.661 5.661 0 00-.226.423c-.006.01-.01.021-.015.033a7.942 7.942 0 00-.708 4.756l.002.017c.024.159.055.32.09.477.002.011.006.02.01.031a8.138 8.138 0 002.79 4.54c.001.002.002.002.003.002.34.279.706.531 1.093.753a7.813 7.813 0 003.253 1.023.62.62 0 00.67-.586.654.654 0 00-.59-.691z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#126FFF"
          fillRule="evenodd"
          stroke="#126FFF"
          strokeWidth="0.3"
          d="M33.173 32.536l-.032 4.322 3.729 2.358a.5.5 0 00.688-.204.529.529 0 00-.213-.703l-3.179-2.053.027-3.692a.527.527 0 00-.506-.532.502.502 0 00-.514.504zm7.759.295a.539.539 0 01-.77.022.563.563 0 01-.037-.783.537.537 0 01.77-.022c.222.21.238.56.037.783zm1.211 2.693a.538.538 0 01-.77.023.563.563 0 01-.036-.784.538.538 0 01.77-.022c.222.21.238.56.036.783zm-.249 2.639a.538.538 0 01-.77.022.562.562 0 01-.036-.784.538.538 0 01.77-.021c.222.21.237.56.036.783zm-2.749 4.21a.538.538 0 01-.77.023.562.562 0 01-.036-.785.538.538 0 01.77-.021c.222.21.237.56.036.783zm-2.552 1.199a.539.539 0 01-.77.023.564.564 0 01-.037-.784.538.538 0 01.77-.022c.223.21.238.56.037.783zm4.19-3.032a.539.539 0 01-.77.023.562.562 0 01-.037-.784.537.537 0 01.77-.022c.223.21.238.562.037.784z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <clipPath id="credential-step-a">
          <path fill="#fff" d="M0 0h48v48H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export default CredentialSteps